import React from "react";
import "./PageLoader.css";

import dtpLogo from "./assets/images/DTP.png";
import filendersLogo from "./assets/images/Filenders.png";

const PageLoader = () => {
    return (
        <div className="transition-loader">
            <div className="transition-loader__blur" />

            <div className="transition-loader__content">
                <img
                    src={dtpLogo}
                    alt="DTP"
                    className="transition-loader__icon"
                />

                <img
                    src={filendersLogo}
                    alt="Filenders"
                    className="transition-loader__brand"
                />

                <div className="transition-loader__progress">
                    <div className="transition-loader__progress-fill" />
                </div>
            </div>
        </div>
    );
};

export default PageLoader;